import { getSocket } from './gateway';
import { getCurrentChannel, onCurrentChannelChange } from './nav';
import { native } from './native';

/**
 * Whether the person can see Spawnwire right now. On the website: the tab is visible and focused. In the
 * Android app: the app is in the foreground (a WebView's focus and visibility don't track that reliably).
 */
export function isActive(): boolean {
  if (native) return native.foreground;
  return document.visibilityState === 'visible' && document.hasFocus();
}

let lastSent: string | null | undefined;

/**
 * Tells the server which conversation is on screen (or none), so it holds back push notifications for it on
 * every device, and tells the app's notification layer the same. `force` resends after a reconnect.
 */
export function sendViewing(force = true): void {
  const channelId = isActive() ? getCurrentChannel() : null;
  native?.viewingChanged(channelId);
  const socket = getSocket();
  if (!socket?.connected) return;
  if (!force && channelId === lastSent) return;
  lastSent = channelId;
  socket.emit('presence:viewing', { channelId });
}

let started = false;

export function startViewingTracking(): void {
  if (started) return;
  started = true;
  const update = () => sendViewing(false);
  window.addEventListener('focus', update);
  window.addEventListener('blur', update);
  document.addEventListener('visibilitychange', update);
  onCurrentChannelChange(update);
}
